export interface ClipboardDeps {
  writeText?: (text: string) => Promise<void>
  execCopy: (text: string) => boolean
}

export type ClipboardPath = { path: 'async' } | { path: 'execCommand'; primaryErr: unknown }

// Tries the async Clipboard API, then the legacy copy; throws the original error
// only when both fail.
export async function writeWithFallback(text: string, deps: ClipboardDeps): Promise<ClipboardPath> {
  let primaryErr: unknown
  if (deps.writeText) {
    try {
      await deps.writeText(text)
      return { path: 'async' }
    } catch (err) {
      primaryErr = err
    }
  }
  if (deps.execCopy(text)) return { path: 'execCommand', primaryErr }
  throw primaryErr ?? new Error('Clipboard unavailable')
}
